import React from "react";
import { Box, Typography } from "@mui/material";
import { logoJpg as logosrc } from "@ippon/shared-assets";

export type CustomBrandLogoProps = {
  label?: string;
};

const CustomBrandLogo: React.FC<CustomBrandLogoProps> = ({ label }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img src={logosrc} alt="Ippon Trading" />
      {label && (
        <Box
          sx={{
            mt: "7px",
            backgroundColor: "#0E9DBC",
            color: "#FFFFFF",
            borderRadius: "200px",
            px: "8px",
            py: "3px",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ fontSize: "10px", lineHeight: 1, fontWeight: 700 }}
          >
            {label}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CustomBrandLogo;
